const escapeXml = (value: string) =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');

const toXmlNode = (key: string, value: unknown): string => {
  const tag = key.replace(/[^a-zA-Z0-9_\-.]/g, '_');

  if (value === null || value === undefined) {
    return `<${tag}/>`;
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return `<${tag}/>`;
    }
    const itemTag = tag.endsWith('s') && tag.length > 1 ? tag.slice(0, -1) : 'item';
    return `<${tag}>${value.map((item) => toXmlNode(itemTag, item)).join('')}</${tag}>`;
  }

  if (typeof value === 'object') {
    const children = Object.entries(value as Record<string, unknown>)
      .map(([childKey, childValue]) => toXmlNode(childKey, childValue))
      .join('');
    return `<${tag}>${children}</${tag}>`;
  }

  return `<${tag}>${escapeXml(String(value))}</${tag}>`;
};

export const objectToXml = (value: unknown, rootName = 'root') =>
  `<?xml version="1.0" encoding="UTF-8"?>\n${toXmlNode(rootName, value)}`;

export const downloadTextFile = (
  content: string,
  filename: string,
  mimeType: string
) => {
  const blob = new Blob([content], { type: `${mimeType};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const downloadJson = (data: unknown, filename: string) => {
  downloadTextFile(
    JSON.stringify(data, null, 2),
    filename.endsWith('.json') ? filename : `${filename}.json`,
    'application/json'
  );
};

export const downloadXml = (data: unknown, filename: string, rootName = 'root') => {
  downloadTextFile(
    objectToXml(data, rootName),
    filename.endsWith('.xml') ? filename : `${filename}.xml`,
    'application/xml'
  );
};

export type ExportFormat = 'json' | 'xml';
